var React = require('react');

function EllipseFillTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.43301 1.75L7 1L6.56699 1.75L2.23686 9.25L1.80385 10H2.66987H11.3301H12.1962L11.7631 9.25L7.43301 1.75ZM13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C10.5899 0.5 13.5 3.41015 13.5 7Z","fill":"#001A45","stroke":"#001A45"}));
}

EllipseFillTriangle.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = EllipseFillTriangle;

EllipseFillTriangle.default = EllipseFillTriangle;
